module.exports = __webpack_public_path__ + "img/step1.e82026c9.png";